// src/components/PaymentButton.js
import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { createCheckoutSession } from '../services/api';

function PaymentButton() {
  const { userGuid, accessToken } = useContext(UserContext);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const handlePaymentClick = async () => {
    setIsLoading(true);
    setError('');
    
    try {
      const response = await createCheckoutSession(userGuid, accessToken);
      
      if (response.url) {
        // Redirect to Stripe Checkout
        window.location.href = response.url;
      } else {
        setError('Failed to create checkout session');
      }
    } catch (error) {
      console.error('Payment error:', error);
      setError(error.message || 'An error occurred while processing your payment');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 3, mb: 3 }}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Upgrade to premium to upload and manage your POLST documents.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handlePaymentClick}
        disabled={isLoading}
      >
        {isLoading ? 'Processing...' : 'Upgrade to Premium'}
      </Button>
      {error && (
        <Typography color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}

export default PaymentButton;